// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectPropertyTypeQueryResult, selectPropertyTypesPageLoading, selectPropertyTypesShowInitWaitingMessage} from '../_selectors/property-type.selectors';

export class PropertyTypesDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectPropertyTypesPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectPropertyTypesShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectPropertyTypeQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
